import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface TextSelectionButtonProps {
  x: number;
  y: number;
  onClick: () => void;
  isRTL?: boolean;
}

const TextSelectionButton: React.FC<TextSelectionButtonProps> = ({
  x,
  y,
  onClick,
  isRTL = false
}) => {
  const { t } = useTranslation();

  return (
    <button
      data-text-selection-ui="true"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Text selection button clicked');
        onClick();
      }}
      className="absolute z-50 bg-white shadow-xl border-2 border-vibrant-orange rounded-full p-1.5 hover:scale-110 transition-all duration-200 hover:shadow-2xl group cursor-pointer"
      style={{
        left: isRTL ? 'auto' : `${x}px`,
        right: isRTL ? `${x}px` : 'auto',
        top: `${y - 50}px`,
        transform: 'translateX(-50%)',
        pointerEvents: 'auto'
      }}
      title={t('exams:practice.textSelection.askAboutSelected')}
    >
      <div className="relative">
        {/* StudyBel Logo */}
        <div className="w-8 h-8 bg-gradient-to-br from-vibrant-orange to-vibrant-orange/90 rounded-full flex items-center justify-center">
          <img
            src="/logo_v2.png"
            alt="StudyBel"
            className="w-12 h-12 object-contain"
          />
        </div>
        
        {/* Question mark overlay */}
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full border border-vibrant-orange flex items-center justify-center">
          <HelpCircle className="w-3 h-3 text-vibrant-orange" />
        </div>
      </div>
    </button>
  );
};

export default TextSelectionButton; 